var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 83,
    viewBox: "0 0 101 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_601_18841)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.5479,
    width: 61,
    height: 41.984,
    rx: 15.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6496 53.4462C65.2178 53.4462 70.5424 48.0397 70.5424 41.3705C70.5424 34.7014 65.2178 29.2949 58.6496 29.2949C55.7059 29.2949 53.012 30.3808 50.9353 32.1796C48.8585 30.3808 46.1647 29.2949 43.221 29.2949C36.6527 29.2949 31.3281 34.7014 31.3281 41.3706C31.3281 48.0397 36.6527 53.4462 43.221 53.4462C46.1647 53.4462 48.8585 52.3603 50.9353 50.5615C53.012 52.3603 55.7059 53.4462 58.6496 53.4462Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9355 50.5616C53.4927 48.3467 55.1142 45.0509 55.1142 41.3705C55.1142 37.6902 53.4927 34.3944 50.9355 32.1795C53.0123 30.3808 55.7061 29.2949 58.6497 29.2949C65.218 29.2949 70.5426 34.7014 70.5426 41.3705C70.5426 48.0397 65.218 53.4462 58.6497 53.4462C55.7061 53.4462 53.0123 52.3603 50.9355 50.5616Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9354 50.5615C53.4925 48.3466 55.1139 45.0508 55.1139 41.3706C55.1139 37.6903 53.4925 34.3946 50.9354 32.1797C48.3783 34.3946 46.7568 37.6903 46.7568 41.3706C46.7568 45.0508 48.3783 48.3466 50.9354 50.5615Z",
    fill: "#FF5E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_601_18841",
    x: 0,
    y: 0.547852,
    width: 101,
    height: 81.9844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_601_18841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_601_18841",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.15fe92687c708c8f7ae9b9adcfca4a72.svg";
export { ForwardRef as ReactComponent };